import styles from "./NavLink.module.css";

const NavLink = (props) => {
  return (
    <a href={props.href} className={styles.link} target={props.target}>{props.children}</a>
  )
}

export default NavLink